export const errorToShow = (error, defaultMessage) => {
  if (typeof error === "string") {
    return error
  } 
  return defaultMessage
}